<!-- Navegação / Navbar (manual da marca 2) -->
<header class="bg-white shadow-sm border-b border-gray-100 h-16 flex-shrink-0 flex items-center justify-between px-4 sm:px-6 lg:px-8 gap-4 animate-fade-in">
  <div class="flex items-center gap-3 min-w-0">
    <button
      type="button"
      class="lg:hidden text-gray-500 hover:text-glico-verde focus:outline-none focus:ring-2 focus:ring-glico-verde focus:ring-offset-2 p-2 rounded-md flex"
      aria-label="Abrir menu"
      (click)="alternarMenu.emit()"
    >
      <mat-icon fontIcon="menu"></mat-icon>
    </button>
    <div class="min-w-0">
      <p class="font-extrabold text-glico-texto truncate m-0">
        Olá, {{ primeiroNome }}! <span class="inline-block aceno">👋</span>
      </p>
      <p class="text-xs text-gray-400 font-semibold hidden sm:block m-0">Painel de acompanhamento Glicosus</p>
    </div>
  </div>

  <div class="flex items-center gap-3">
    <div class="hidden md:inline-flex items-center gap-2 bg-gray-50 border border-gray-100 text-gray-600 font-bold text-sm px-3 py-1.5 rounded-full">
      <span class="w-2 h-2 rounded-full bg-glico-verde pulso"></span>
      {{ currentDateTime }}
    </div>
    <div
      class="w-9 h-9 rounded-full bg-glico-verde_claro text-glico-verde_escuro font-extrabold flex items-center justify-center text-sm"
      [matTooltip]="nomeUsuario || ''"
    >
      {{ iniciais }}
    </div>
    <button
      type="button"
      class="btn-sair text-gray-400 hover:text-glico-alerta hover:bg-red-50 transition-colors p-2 rounded-full flex"
      matTooltip="Sair"
      aria-label="Sair"
      (click)="logout()"
    >
      <mat-icon fontIcon="logout"></mat-icon>
    </button>
  </div>
</header>
